import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export const BASE_URL_API = 'https://badmintonperu.com/aulavirtual-api/api';
export const BASE_URL_UPLOAD = 'https://badmintonperu.com/aulavirtual-api/api/common/upload';
export const BASE_URL_PUBLIC = 'https://badmintonperu.com/aulavirtual-api/public/';

//export const BASE_URL_API = 'http://localhost:4610/api';
//export const BASE_URL_UPLOAD = 'http://localhost:4610/api/common/upload';
//export const BASE_URL_PUBLIC = 'http://localhost:4610/public/';
export let MENU_SITE = [
   {
    'name' : 'Home',
    'route' : '/home',
    'icon' : 'fa fa-home',
    'active' :  true
   },
   {
    'name' : 'Contáctenos',
    'route' : '/contact',
    'icon' : 'fa fa-id-card-o',
    'active' :  false
   }
];

export let MENU_SITE_INSTRUCTOR = [

  {
   'name' : 'Listado de curso',
   'route' : '/instructor/courses',
   'icon' : 'fa fa-id-card-o',
   'active' :  false
  }
];
//export let COURSE_IS_EDIT:boolean = false;

@Injectable({
  providedIn: 'root'
})


export class AppService {

  public endpoint = '/';

  constructor(
    public http: HttpClient
  ) {}


  public generateHeaders(type?: any): HttpHeaders {
    let token = null;
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token');
    }
    let httpHeaders = null;
    if (token) {
      httpHeaders = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + token});
    } else {
      httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
    }
    return httpHeaders;
  }

  public generateHeadersAuthorization(): HttpHeaders {
    const credenciales = btoa('osiptel' + ':' + '1234567890');
    const httpHeaders = new HttpHeaders({
      Authorization: 'Basic ' + credenciales
    });
    return httpHeaders;
  }

  get<T>(url: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.get<T[]>(url, {headers, responseType: type});
  }

  postAuthorization(url: any, object: any, headers?: HttpHeaders): Observable<any> {
    //const headers = this.generateHeadersAuthorization();
    return this.http.post(url, object, {headers, responseType: 'json'});
  }

  post(url: any, object: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.post(url, object, {headers, responseType: 'json'});
  }

  patch(url, data: any, accessToken: string = null): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.patch(url, data, {headers});
  }

  put(url: any, object: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.put(url, object, {headers, responseType: type});
  }

  delete(url: any, type?: any): Observable<any> {
    const headers = this.generateHeaders(type);
    return this.http.delete(url, {headers, responseType: type});
  }

  generate(url: any, object: any): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.post(url, object, {headers, responseType: 'blob'});
  }

  request(req: any): Observable<any> {
    const token = JSON.parse(localStorage.getItem('currentUser')).access_token;
    const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + token});
    return this.http.request(req);
  }


}
